import dotProp from 'dot-prop-immutable';

import {
    REDUCE_BROKER,
    REDUCE_BROKER_ELEMENT,
    REDUCE_BROKER_HANDLE_CODE,
    REDUCE_BROKER_HANDLE_ERROR,
    REDUCE_BROKER_HANDLE_IMAGE,
    REDUCE_BROKER_SETTINGS,
    REDUCE_BROKER_SETTINGS_ELEMENT,
    REDUCE_BROKERS,
    REDUCE_ENTITY,
    REDUCE_QUERY_ELEMENT,
    REDUCE_SOCIAL_AND_BOOKING_SETUP_ELEMENT,
    REDUCE_SOCIAL_MEDIA_AND_BOOKING_SETUP,
    REDUCE_VELOCITY_CONFIG,
    REDUCE_VELOCITY_CONFIG_ELEMENT,
    REDUCE_VELOCITY_IMPORT_HISTORY,
} from '../../constants/actions/broker';

const initialState = {
    entity: null,
    broker: null,
    brokerHandle: {
        code: null,
        brokerImage: {
            pictureBlob: null,
            pictureFileName: null,
            isPictureDeleted: null,
            isPictureUpdated: null,
        },
        error: null,
    },
    socialMediaAndBookingSetup: null,
    brokerSettings: null,
    velocityConfig: null,
    velocityImportHistory: [],
    query: {
        take: 25,
        skip: 0,
        orderByDesc: true,
    },
    brokers: [],
};

function brokerReducer(state = initialState, action) {
    switch (action.type) {
        case REDUCE_ENTITY:
            return dotProp.set(state, 'entity', action.payload);
        case REDUCE_BROKER_ELEMENT:
            return dotProp.set(state, `broker.${action.payload.code}`, action.payload.value);
        case REDUCE_BROKER:
            return dotProp.set(state, 'broker', action.payload);
        case REDUCE_BROKER_HANDLE_CODE:
            return dotProp.set(state, 'brokerHandle.code', action.payload);
        case REDUCE_BROKER_HANDLE_IMAGE:
            return dotProp.set(state, 'brokerHandle.brokerImage', action.payload);
        case REDUCE_SOCIAL_MEDIA_AND_BOOKING_SETUP:
            return dotProp.set(state, 'socialMediaAndBookingSetup', action.payload);
        case REDUCE_BROKER_SETTINGS:
            return dotProp.set(state, 'brokerSettings', action.payload);
        case REDUCE_BROKER_SETTINGS_ELEMENT:
            return dotProp.set(state, `brokerSettings.${action.payload.code}`, action.payload.value);
        case REDUCE_SOCIAL_AND_BOOKING_SETUP_ELEMENT:
            return dotProp.set(state, `socialMediaAndBookingSetup.${action.payload.code}`, action.payload.value);
        case REDUCE_VELOCITY_CONFIG:
            return dotProp.set(state, 'velocityConfig', action.payload);
        case REDUCE_VELOCITY_CONFIG_ELEMENT:
            if (!state.velocityConfig) {
                return dotProp.set(state, 'velocityConfig', { [action.payload.code]: action.payload.value });
            }
            return dotProp.set(state, `velocityConfig.${action.payload.code}`, action.payload.value);
        case REDUCE_VELOCITY_IMPORT_HISTORY:
            return dotProp.set(state, 'velocityImportHistory', action.payload);
        case REDUCE_QUERY_ELEMENT:
            return dotProp.set(state, `query.${action.payload.code}`, action.payload.value);
        case REDUCE_BROKERS:
            return dotProp.set(state, 'brokers', action.payload);
        case REDUCE_BROKER_HANDLE_ERROR:
            return dotProp.set(state, 'brokerHandle.error', action.payload);
        default:
            return state;
    }
}

export default brokerReducer;
